import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import {getAwsCredentials, getUserSessionCookie} from "@/utils/Auth";
import router from "@/router";
import { apiRedirectPages } from "@/constants/constant";
import axios from "axios";

// getUserDataを実行
export function getUserDataLambdaInvoke(files) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({ files });
    doLambdaInvoke("getUserData", data)
      .then((res) => {
        resolve(res.Item);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getUserDataForMemberを実行 BM系の編集formで使用する
export function getUserDataForMemberLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("getUserDataForMember", data)
      .then((res) => {
        resolve(res.Item);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateProfileを実行
export function validateProfileLambdaInvoke(profile) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(profile);
    doLambdaInvoke("validateProfile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateWorkplaceを実行
export function validateWorkplaceLambdaInvoke(workplace) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(workplace);
    doLambdaInvoke("validateWorkplace", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateDebtを実行 EN-004
export function validateDebtLambdaInvoke(debt) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(debt);
    doLambdaInvoke("validateDebt", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateIdentifyFileを実行
export function validateIdentifyFileLambdaInvoke(identifyFile) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(identifyFile);
    doLambdaInvoke("validateIdentifyFile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateEditIdentifyFileを実行
export function validateEditIdentifyFileLambdaInvoke(identifyFile) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(identifyFile);
    doLambdaInvoke("validateEditIdentifyFile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitIdentifyFileを実行
export function submitIdentifyFileLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitIdentifyFile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitEditIdentifyFileを実行
export function submitEditIdentifyFileLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitEditIdentifyFile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// contractAgreement を実行 EN-012
export function contractAgreementLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("contractAgreement", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// completeContractAgreement を実行 EN-013
export function completeContractAgreementLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("completeContractAgreement", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getContractPdf を実行 EN-013
export function getContractPdfLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("getContractPdf", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitContractAgreement を実行 EN-012
export function submitContractAgreementLambdaInvoke(contractAgreement) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(contractAgreement);
    doLambdaInvoke("submitContractAgreement", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateSecretQuestions を実行 EN-015
export function validateSecretQuestionsLambdaInvoke(secretQuestions) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(secretQuestions);
    doLambdaInvoke("validateSecretQuestions", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitSecretQuestions を実行 EN-016
export function submitSecretQuestionsLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitSecretQuestions", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitConfirmationCodeを実行 EN-020
export function submitConfirmationCodeLambdaInvoke(confirmationCode) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(confirmationCode);
    // data = {} // TODO 削除
    doLambdaInvoke("submitConfirmationCode", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// membersIndex を実行 MB-001
export function membersIndexLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("membersIndex", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// tradingHistory を実行 MB-004
export function tradingHistoryLambdaInvoke(
  periodCovered,
  monthlyStatementYear
) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({
      period_covered: periodCovered,
      monthly_statement_year: monthlyStatementYear,
    });
    doLambdaInvoke("tradingHistory", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// checkPincode を実行 MB-010
export function checkPincodeLambdaInvoke(checkPincode) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(checkPincode);
    doLambdaInvoke("checkPincode", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// checkPincode を実行 MB-011
export function validateDepositIntoAccountLambdaInvoke(
  validateDepositIntoAccount
) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(validateDepositIntoAccount);
    doLambdaInvoke("validateDepositIntoAccount", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// depositIntoAccount を実行 MB-011
export function depositIntoAccountLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("depositIntoAccount", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// depositIntoPrepaid を実行 MB-012
export function depositIntoPrepaidLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("depositIntoPrepaid", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateDepositIntoPrepaid を実行 MB-012
export function validateDepositIntoPrepaidLambdaInvoke(
  validateDepositIntoPrepaid
) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(validateDepositIntoPrepaid);
    doLambdaInvoke("validateDepositIntoPrepaid", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getPdfFile を実行 MB-012
export function getPdfFileLambdaInvoke(pdf) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(pdf);
    doLambdaInvoke("getPdfFile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitDepositIntoAccount を実行 MB-013
export function submitDepositIntoAccountLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitDepositIntoAccount", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitDepositIntoAccount を実行 MB-014
export function submitDepositIntoPrepaidLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitDepositIntoPrepaid", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// refundFromAccount を実行 MB-015
export function refundFromAccountLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("refundFromAccount", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// refundFromPrepaid を実行 MB-018
export function refundFromPrepaidLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("refundFromPrepaid", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateRefundFromPrepaid を実行 MB-018
export function validateRefundFromPrepaidLambdaInvoke(
  validateRefundFromPrepaid
) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(validateRefundFromPrepaid);
    doLambdaInvoke("validateRefundFromPrepaid", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// // membersIndex を実行 MB-019 使わなくなった
// export function contractDetailLambdaInvoke () {
//   return new Promise(function (resolve, reject) {
//     let data = dataValueToString({})
//     doLambdaInvoke('contractDetail', data).then(res => { resolve(res) }).catch(error => { reject(error) })
//   })
// }

// contractPdfList を実行 MB-020
export function contractPdfListLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("contractPdfList", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// accountInfo を実行 MB-021
export function accountInfoLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("accountInfo", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// editProfile を実行 MB-024
export function editProfileLambdaInvoke(userData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(userData);
    doLambdaInvoke("editProfile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// editWorkplace を実行 MB-025
export function editWorkplaceLambdaInvoke(workplace) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(workplace);
    doLambdaInvoke("editWorkplace", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// editMailaddress を実行 MB-026
export function editMailaddressLambdaInvoke(profile) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(profile);
    doLambdaInvoke("editMailaddress", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitProfile を実行 EN-005
export function submitAttributesLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitAttributes", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitProfile を実行 MB-027
export function submitEditProfileLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitEditProfile", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// changePhoneNumber を実行 MB-066
export function changePhoneNumberLambdaInvoke(userData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(userData);
    doLambdaInvoke("changePhoneNumber", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// diffKeys を実行 MB-027, MB-028, MB-029
export function diffkyesLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("diffKeys", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitWorkplace を実行 MB-028
export function submitEditWorkplaceLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitEditWorkplace", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitMailaddress を実行 MB-029
export function submitMailaddressLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitEditMailaddress", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// // submitPincode を実行 MB-031
// export function submitPincodeLambdaInvoke () {
//   return new Promise(function (resolve, reject) {
//     let data = dataValueToString({})
//     doLambdaInvoke('submitPincode', data).then(res => { resolve(res) }).catch(error => { reject(error) })
//   })
// }

// checkSecretWord を実行 MB-031
export function checkSecretWordLambdaInvoke(secretQuestions) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(secretQuestions);
    doLambdaInvoke("checkSecretWord", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// // editPincode を実行 MB-032
// export function editPincodeLambdaInvoke (pincode) {
//   return new Promise(function (resolve, reject) {
//     let data = dataValueToString(pincode)
//     doLambdaInvoke('editPincode', data).then(res => { resolve(res) }).catch(error => { reject(error) })
//   })
// }
// validatePincode を実行 MB-032
export function validatePincodeLambdaInvoke(pincode) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(pincode);
    doLambdaInvoke("validatePincode", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitRefundFromPrepaid を実行 MB-039
export function submitRefundFromPrepaidLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitRefundFromPrepaid", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitAccountInfo を実行 TEM-012
export function submitAccountInfoLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("submitAccountInfo", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getNoticeListを実行
export function getNoticeListLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("getNoticeList", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getNoticeInfoを実行
export function getNoticeInfoLambdaInvoke(noticeInfo) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(noticeInfo);
    doLambdaInvoke("getNoticeInfo", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// checkLocalLoginを実行 CE-002
export function checkLocalLoginLambdaInvoke(loginData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(loginData);
    doLambdaInvoke("checkLocalLogin", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// checkLocalLoginを実行 CE-003
export function getSecretWordKeysLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("getSecretWordKeys", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// checkLocalIdを実行 CE-003
export function checkLocalIdLambdaInvoke(localIdData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(localIdData);
    doLambdaInvoke("checkLocalId", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// validateLocalUserDataを実行 CE-006
export function validateLocalUserDataLambdaInvoke(localUserData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(localUserData);
    doLambdaInvoke("validateLocalUserData", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitLocalIdDataを実行 CE-004
export function submitLocalIdLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString();
    doLambdaInvoke("submitLocalId", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// deleteTmpUserDataを実行
export function deleteTmpUserDataLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("deleteTmpUserData", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getAccountIdを実行
export function getAccountIdLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("getAccountId", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// getUserSessionを実行
export function getUserSessionLambdaInvoke() {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString({});
    doLambdaInvoke("getUserSession", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// submitPutBankAccountを実行
export function submitPutBankAccountLambdaInvoke(bankData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(bankData);
    doLambdaInvoke("submitPutBankAccount", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// registDeviceInfoData を実行
export function registDeviceInfoDataLambdaInvoke(deviceInfoData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(deviceInfoData);
    doLambdaInvoke("registDeviceInfoData", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// registFormEventData を実行
export function registFormEventDataLambdaInvoke(eventData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(eventData);
    dotFormEvenLambdaInvoke("registFormEventData", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// SMS送信 を実行
export function otpSmsSendLambdaInvoke(eventData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(eventData);
    dotFormEvenLambdaInvoke("otpSmsSend", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// SMS入力チェック を実行
export function otpInputLambdaInvoke(eventData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(eventData);
    dotFormEvenLambdaInvoke("otpInput", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 口座番号認証 を実行
export function checkBankauthLambdaInvoke(eventData) {
  return new Promise(function (resolve, reject) {
    let data = dataValueToString(eventData);
    doLambdaInvoke("checkBankauth", data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function doLambdaInvoke(functionName, data) {
  // Lambdaクライアントを初期化
  const credentials = getAwsCredentials();
  const client = new LambdaClient({ region: "ap-northeast-1", credentials });

  data["user_session"] = getUserSessionCookie();
  const payload = {
    FunctionName: `${functionName}:provisioned`,
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({ inputs: data }),
  };

  const command = new InvokeCommand(payload);
  const response = await client.send(command);

  // ペイロードはUint8Arrayなのでデコード
  const decoder = new TextDecoder("utf-8");
  const resultString = decoder.decode(response.Payload);
  const result = JSON.parse(resultString);

  if (result && result.body) {
    const body = JSON.parse(result.body);
    const status = body.api_status;
    if (status in apiRedirectPages) {
      router.push({ name: apiRedirectPages[status] });
      throw new Error("api_status: " + status);
    }
  }

  if (result.errorMessage) {
    throw new Error(result.errorMessage);
  }
  return result;
}


async function dotFormEvenLambdaInvoke(functionName, data) {
  // Lambdaクライアントを初期化
  const credentials = getAwsCredentials();
  const client = new LambdaClient({ region: "ap-northeast-1", credentials });

  data["user_session"] = getUserSessionCookie();
  const params = {
    FunctionName: `${functionName}:provisioned`,
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({ inputs: data }),
  };
  const command = new InvokeCommand(params);
  const response = await client.send(command);
  const decoder = new TextDecoder("utf-8");
  const result = JSON.parse(decoder.decode(response.Payload));
  if (result && result.body) {
    const body = JSON.parse(result.body);
    const status = body.api_status;
    if (status in apiRedirectPages) {
      router.push({ name: apiRedirectPages[status] });
      throw new Error("api_status: " + status);
    }
  }
  if (result && result.errorMessage) {
    throw new Error(result.errorMessage);
  }
  return result;
}

// リクエストパラメータのValueをStringにキャスト
function dataValueToString(data) {
  for (let key in data) {
    if (data[key]) {
      data[key] = data[key].toString();
    }
  }
  return data;
}

export function apiGetPdfFile(params) {
  return new Promise(function (resolve, reject) {
    callApi(process.env.VUE_APP_GET_PDF_FILE, params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function apiGetContractPdf(params) {
  return new Promise(function (resolve, reject) {
    callApi(process.env.VUE_APP_GET_CONTRACT_PDF, params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function callApi(url, params) {
  return new Promise(function (resolve, reject) {
    axios
      .get(url, { params: params }, { responseType: "blob" })
      .then((res) => {
        if (res.data === "") {
          reject(new Error(res.error_message));
        }
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
